const columns = [{
    title: "Name",
    dataIndex: "employee_name",
    scopedSlots: { customRender: 'employee_name' },
},
{
    title: "Username",
    dataIndex: "username",
    scopedSlots: { customRender: 'username' },
},
{
    title: "Work Schedule Code",
    dataIndex: "work_schedule_code",
    class: 'cursor-pointer',
    scopedSlots: { customRender: 'work_schedule_code' },
},
{
    title: "Start Date",
    dataIndex: "effective_start_date",
    scopedSlots: { customRender: 'effective_start_date' },
    name: "effective_start_date",
},
{
    title: "End Date",
    dataIndex: "end_date",
    scopedSlots: { customRender: 'end_date' },
    name: "end_date",
},
{
    title: "Work Start Time",
    dataIndex: "work_start_time",
    name: "work_start_time",
    scopedSlots: { customRender: "work_start_time" },
},
{
    title: "Work End Time",
    dataIndex: "work_end_time",
    name: "work_end_time",
    scopedSlots: { customRender: "work_end_time" },
},
{
    title: "",
    dataIndex: "",
    name: "action",
    scopedSlots: { customRender: "action" },
},
];


import FilterLayout from "../../components/layouts/FilterLayout";
import { mapState } from "vuex";
import { formatDate, formatTime, scaleScreen, convertObjectToParams } from "../../components/commons/commons";
import { Role } from "../../components/commons/commonConstant";
import moment from "moment";
export default {
    name: 'Employee',
    components: {
        FilterLayout,
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
            roles: state => state.user.userInfo.roles ? state.user.userInfo.roles : "",
            timesheetUser: (state) => state.timesheet.timesheetUser ? state.timesheet.timesheetUser : {},
            lastTimesheet: state => state.application.lastTimesheet,
            workscheduleList: state => state.application.workscheduleList,
            employeeList: state => state.application.employeeList,
            jobInfoList: state => state.jobinfo.jobInfoList,
        })
    },
    created() {
        this.$store.dispatch("application/getWorkScheduleList");
        this.getJobInfo();
        this.scaleScreen();
        this.dataFilters = { ...this.dataFilters, ...JSON.parse(sessionStorage.getItem(this.page)) }
    },
    data() {
        return {
            page: 'Job Info History',
            dataSource: [],
            columns,
            loading: false,
            dataFilters: {},
            pagination: {},
            role: Role,
            currentPage: 1,
            pageSize: 10,
            total_items: 0,
            visibleModal: false,
            size: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
            form: this.$form.createForm(this, { name: 'job-info-history' }),
            id: null,
            startdate: null,
            enddate: null,
            ids: '',
            isEdit: false,
            work_schedule: {},
            fetching: false,
        }
    },
    methods: {
        scaleScreen,
        formatDate,
        formatTime,
        onSetDataFilters(filters) {
            this.dataFilters = filters;
            this.getJobInfo();
        },
        onApplyFilters(filters) {
            this.dataFilters = filters;
            this.currentPage = 1
            this.getJobInfo()
        },
        onChangePage(page, size) {
            this.currentPage = page;
            this.pageSize = size;
            this.getJobInfo();
        },
        onSearchStaff(value, timeout) {
            let cloneVal = decodeURI(value);
            if (value && value !== "" && value.length >= 3) {
                this.fetching = true;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.$store
                        .dispatch("application/getEmployeeList", cloneVal)
                        .then(() => {
                            this.fetching = false;
                        })
                        .catch(() => {
                            this.fetching = false;
                        });
                }, timeout);

            }
        },
        getJobInfo() {
            this.$store.dispatch('user/loadingRequest');
            const { currentPage, pageSize, dataFilters } = this
            let param = {};
            if (this.firstCall) {
                param = { ...dataFilters }
                this.currentPage = dataFilters.page ? dataFilters.page : 1
                this.pageSize = dataFilters.size ? dataFilters.size : 10
            } else {
                param = { ...dataFilters, page: currentPage, size: pageSize }
            }
            const url = convertObjectToParams(param)
            this.$store.dispatch("jobinfo/getAllJobInfo", url).then((res) => {
                let data = []
                if (res.data) {
                    data = res.data.map((element, key) => {
                        element.key = key
                        return element
                    })
                    this.firstCall = false
                    this.dataSource = data
                    this.total_items = res.page.total_element
                }
                this.$store.dispatch('user/loadingRequest')
            }).catch((error) => {
                this.$message.error(error, 5)
                this.$store.dispatch('user/loadingRequest')
            });
            sessionStorage.setItem(this.page, JSON.stringify(param))
        },
        filterSubmit(payload) {
            this.$store.dispatch('jobinfo/filterJobInfo', payload).then((res) => {
                if (res) {
                    this.$message.success(res.message)
                }
            }).catch((err) => {
                this.$message.error(err.message, 5)
            })
        },
        tabsEmployeeCreate(tabs) {
            this.activeKey = tabs;
        },
        async showModalCreate() {
            this.form.resetFields()
            this.isEdit = false;
            this.visibleModal = true;
            this.startdate = null;
            this.enddate= moment('9999-12-30T17:00:00.000+0000');
        },
        handleCancel() {
            this.form.resetFields()
            this.visibleModal = false;
        },

        async showModalEdit(data) {
            this.form.resetFields()
            this.work_schedule = data.work_schedule_code;
            this.id = data._id
            this.ids = ''
            this.startdate = data.effective_start_date
            this.enddate = data.end_date
            this.isEdit = true;
            this.visibleModal = true
        },

        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (this.isEdit) {
                        values['_id'] = this.id;
                        this.$store.dispatch('jobinfo/updateJobInfo', values).then((res) => {
                            if (res.code === '000513') {
                                this.$message.error(res.message)
                            }
                            else{
                                this.$message.success(res.message)
                            }
                            this.getJobInfo();
                            this.form.resetFields()
                            this.visibleModal = false;
                        }).catch((error) => {
                            this.$message.error(error.message, 5)
                        })
                    } else {
                        values['end_date'] = values['end_date'].format('YYYY-MM-DD')
                        values['effective_start_date'] = moment(values['effective_start_date']).format('YYYY-MM-DD');
                        values['_id'] = this.ids
                        this.$store.dispatch('jobinfo/createJobInfo', values).then((res) => {
                            if (res) {
                                this.getMessageSubmit(res)
                                this.form.resetFields();
                                this.getJobInfo();
                                this.visibleModal = false;
                            }
                        }).catch((error) => {
                            this.$message.error(error.message, 5)
                        })
                    }

                }
            })
        },
        getMessageSubmit(res) {
            if(res.data && res.data.length) {
                for(let value of res.data) {
                    this.$message.success(value)
                }
            } else {
                this.$message.error(res.message)
            }
        },
        setID(id) {
            this.ids = ''
            for (let value of id) {
                this.ids += JSON.parse(value).id.concat(',');
            }
            this.ids = this.ids.substring(0, this.ids.length - 1);
        },
        setStartDate(value) {
            this.startdate = moment(value).format('YYYY-MM-DD');
        },
        setEndDate(value) {
            this.enddate = moment(value).format('YYYY-MM-DD');
        }
        // remove(id) {
        //     const vm = this
        //     this.$confirm({
        //         title: 'Are you sure delete this Job info ?',
        //         okText: 'Yes',
        //         okType: 'danger',
        //         cancelText: 'No',
        //         onOk() {
        //             vm.$store.dispatch('jobinfo/removeJobInfo', id).then((res) => {
        //                 if (res) {
        //                     vm.$message.success(res.message)
        //                     vm.getJobInfo();
        //                 }
        //             }).catch((err) => {
        //                 vm.$message.error(err.message, 5)
        //             })
        //         },
        //         onCancel() {

        //         },
        //     });

        // },

    },
}